<form class="mb-3" [formGroup]="createContactForm" (ngSubmit)="onFilter()">
  <div class="card col-12 mb-4">
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-md-3 mb-3 form-group">
          <label class="form-label" for="MetroQuadradoDe">M2 De</label>
          <input
            type="text"
            class="form-control form-control-sm"
            id="MetroQuadradoDe"
            formControlName="MetroQuadradoDe"
          />
        </div>
        <div class="col-12 col-md-3 mb-3 form-group">
          <label class="form-label" for="MetroQuadradoAte">M2 Ate</label>
          <input
            type="text"
            class="form-control form-control-sm"
            id="MetroQuadradoAte"
            formControlName="MetroQuadradoAte"
          />
        </div>
        <div class="col-12 col-md-3 mb-3 form-group">
          <label class="form-label" for="Feira">Feira <span class="text-danger">*</span></label>
          
          <!-- Container do select com busca integrada -->
          <div class="position-relative">
            <div class="dropdown" [class.show]="dropdownFeiraAberto">
              <!-- Input de busca que simula um select -->
              <input
                type="text"
                class="form-control form-control-sm dropdown-toggle"
                [class.is-invalid]="createContactForm.get('FeiraId')?.invalid && createContactForm.get('FeiraId')?.touched"
                placeholder="Selecione uma feira..."
                [(ngModel)]="buscaFeira"
                (input)="buscaFeiraDebounce$.next(buscaFeira || '')"
                (focus)="abrirDropdownFeira()"
                (blur)="fecharDropdownFeira()"
                [ngModelOptions]="{standalone: true}"
                autocomplete="off"
              >
              
              <!-- Dropdown com opções -->
              <div 
                class="dropdown-menu w-100" 
                [class.show]="dropdownFeiraAberto" 
                style="max-height: 200px; overflow-y: auto;"
                (scroll)="onScrollFeiras($event)"
              >
                <div *ngIf="feirasFiltradas.length === 0 && !feiraPaginas.carregandoMais" class="dropdown-item-text text-muted">
                  Nenhuma feira encontrada
                </div>
                <a 
                  *ngFor="let feira of feirasFiltradas; trackBy: trackByFeira" 
                  class="dropdown-item" 
                  href="#"
                  (mousedown)="selecionarFeira(feira)"
                >
                  {{ feira.nome }}
                </a>
                <div *ngIf="feiraPaginas.carregandoMais" class="dropdown-item-text text-center">
                  <div class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Carregando...</span>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Hidden select para manter a validação do formulário -->
            <select
              id="Feira"
              class="d-none"
              formControlName="FeiraId"
            >
              <option value="">Selecione uma feira</option>
            </select>
          </div>
          
          <div class="invalid-feedback d-block" *ngIf="createContactForm.get('FeiraId')?.invalid && createContactForm.get('FeiraId')?.touched">
            Feira é obrigatória
          </div>
        </div>
        <div class="col-12 col-md-3 mb-3 form-group">
          <label class="form-label" for="StatusId">Status</label>

          <select class="form-select form-select-sm" id="StatusId" formControlName="StatusId">
            @if (isStatusMessagesArray && statusMessages.length > 0) {
              @for (message of statusMessages; track message.id) {
                <option value="{{ message.id }}">{{ message.nome }}</option>
              }
            }
          </select>
        </div>

        <div class="col-12 col-md-3 mb-3 form-group">
          <label for="DataAgendamentoDe" class="form-label">
            Agendamento de
          </label>
          <input
            class="form-control form-control-sm"
            type="date"
            value=""
            id="DataAgendamentoDe"
          />
        </div>
        <div class="col-12 col-md-3 mb-3 form-group">
          <label for="DataAgendamentoAte" class="form-label">
            Agendamento até
          </label>
          <input
            class="form-control form-control-sm"
            type="date"
            value=""
            id="DataAgendamentoAte"
          />
        </div>

        <div
          class="col-12 col-md-6 mb-3 form-group align-self-end mx-auto d-flex justify-content-between"
        >
          <button class="btn btn-primary" type="submit">Filtrar</button>
          @if (showCreateListButton) {
            <button
              class="btn btn-secondary"
              type="button"
              (click)="openCreateListModal()"
            >
              Criar lista
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</form>
